// lib
import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import { default as ComponentContainer } from '@aytm/app/stats/page/question-views/components/questions-custom/Component'

import { Dropdown } from 'primereact/dropdown'

import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'
import ScriptItemText from '@aytm/app/stats/page/question-views/xq/components/ScriptItemText'
import ScriptItemSelect from '@aytm/app/stats/page/question-views/xq/components/ScriptItemSelect'

import Controls from '@aytm/app/stats/page/question-views/xq/components/Controls'
import Footer from '@aytm/app/stats/page/question-views/components/questions-custom/Footer'

// styles
import style from '@aytm/app/stats/page/question-views/xq/styles/Component.module.scss'

export const DataContext = React.createContext()

const Component = ({ model, data, basic, scripts, states, disabled, onSelect, onChange, onUpdateData }) => {
  const { script, args } = model

  const scriptsRef = useRef()

  const scriptsOptions = useMemo(
    () =>
      scripts.map(r =>
        r instanceof Object
          ? { key: r.value, text: r.text, description: r.description }
          : { key: r, text: r, description: r }
      ),
    [scripts]
  )

  const setTitle = description => {
    const element = scriptsRef.current.querySelector('.p-dropdown-info')
    if (null === element) return

    const txt = document.createElement('textarea')

    txt.innerHTML = description || (script && script.description) || ''

    element.style.setProperty('--description', `"${txt.value.replace(/\n/g, ' ')}"`)
  }

  const itemTemplate = option => (
    <span onMouseEnter={() => setTitle(option.description)} dangerouslySetInnerHTML={{ __html: option.text }}></span>
  )
  const valueTemplate = option =>
    option ? <span dangerouslySetInnerHTML={{ __html: option.text }}></span> : 'Please select...'

  const dataContextValue = useMemo(() => {
    return {
      model,
      data,
      disabled,
      onChange
    }
  }, [model, data, disabled, onChange])

  const renderScriptItem = item => {
    const value = args[item.id]

    switch (item.input) {
      case 'select': {
        return <ScriptItemSelect key={item.id} item={item} value={value} multiple={false} />
      }
      case 'multi-select': {
        return <ScriptItemSelect key={item.id} item={item} value={value} multiple />
      }
      default: {
        return <ScriptItemText key={item.id} item={item} value={value} basic={(basic && basic[item.id]) || []} />
      }
    }
  }

  return (
    <BlockWrapper>
      <ComponentContainer Controls={Controls} model={model} data={data} states={states} disabled={disabled}>
        <div className={style.component}>
          {0 < scripts.length ? (
            <>
              <div className={style.row}>
                <div ref={scriptsRef} className="p-fluid p-col-12" onMouseLeave={() => setTitle()}>
                  <Dropdown
                    data-testid={`stat-xq-script-picker-${model?.id}`}
                    className="p-dropdown-rounded p-dropdown-info"
                    aria-label="Script"
                    ariaLabel="Script"
                    placeholder={'Please select...'}
                    value={(script && script.id) || null}
                    options={scriptsOptions}
                    optionValue="key"
                    optionLabel="text"
                    fixedDropdownDir="bottom"
                    disabled={disabled}
                    itemTemplate={itemTemplate}
                    valueTemplate={valueTemplate}
                    onChange={
                      disabled
                        ? null
                        : event => {
                            const description = scripts.find(v => event.value === v.value).description
                            setTitle(description)
                            onSelect(event.value)
                          }
                    }
                  />
                </div>
              </div>
              <div className={style.list}>
                <DataContext.Provider value={dataContextValue}>
                  {script != undefined && script.args.map(item => renderScriptItem(script.manifest[item.id]))}
                </DataContext.Provider>
              </div>
            </>
          ) : 'string' == typeof states.error ? null : (
            <div className={style.row}>Loading scripts...</div>
          )}
        </div>
        {!disabled && <Footer model={model} states={states} onUpdateData={onUpdateData} />}
      </ComponentContainer>
    </BlockWrapper>
  )
}

Component.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  basic: PropTypes.object,
  scripts: PropTypes.array,
  states: PropTypes.object,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  onUpdateData: PropTypes.func
}

Component.displayName = 'Component'

export default Component
